import React, {Fragment} from 'react';
import connect from "../../../reducers/connect";
import createEditor from "../../form/ComponentEditor";
import {sendRequest} from "../../../utils/request";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import Button from "../../form/Button";
import Box from "../../layout/Box";
import {loadComponentById} from "../../../utils/components";
import ContentLoader from "../../layout/ContentLoader";
import debounce from "lodash-es/debounce";
import isEqual from "lodash-es/isEqual";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    AddressFormatter,
    CurrencyFormatter,
    DateFormatter,
    remoteComponentFormatter,
    UnitFormatter
} from "../../../utils/formatters";
import moment from "moment";
import {componentFilter} from "../../../utils/filters";
import Select from "../../form/Select";
import * as formatters from "../../../utils/formatters";
import {get, set} from "../../../utils/dotutils";
import TextInput from "../../form/TextInput";
import DateTimeInput from "../../form/DateTimeInput";
import {fullyear, halfyears, months, quarters} from "../../../utils/other";
import RadioGroup from "../../form/RadioGroup";
import {Tooltip} from "react-tippy";
import CheckBox from "../../form/CheckBox";



// import PivotTableUI from 'react-pivottable/PivotTableUI';
// import 'react-pivottable/pivottable.css';

// see documentation for supported input formats
/* const data = [
    {
        product: 1,
        purchase: 1,
        //...
    },
    {
        product: 2,
        purchase: 3,
        //...
    },
    {
        product: 9,
        purchase: 10,
        //...
    },
    //...
];*/












const renderers = {
    currency: CurrencyFormatter,
    address: AddressFormatter,
    unit: (value, row) => UnitFormatter(value, row.unit),
    percent: (value) => {
        return <span className="percent">{parseFloat(value || 0).toFixed(2) + "%"}</span>;
    },
    percentage: (value) => {
        return <span className="percent">{(parseFloat(value || 0) * 100).toFixed(2) + "%"}</span>;
    },
    date: DateFormatter,
    pos: (value) => <div className="nowrap">{remoteComponentFormatter({component: "PointOfSale", labelfield: "name"})(value)}</div>,
    ProductCategory: (value) => <div className="nowrap">{remoteComponentFormatter({component: "ProductCategory", labelfield: "name"})(value)}</div>,
    series: (value) => <div className="nowrap">{remoteComponentFormatter({component: "series", labelfield: "title"})(value)}</div>,
    month: (value) => moment().month(value - 1).format("MMMM"),
    day: (value, rowdata) => <span className="nowrap">{value + ". " + moment(rowdata.year + "-" + rowdata.month + "-" + rowdata.day, "YYYY-MM-DD").format("dddd")}</span>
};

const filterables = {
    pos: componentFilter({component: "PointOfSale", labelfield: "name"}),
    ProductCategory: componentFilter({component: "ProductCategory", labelfield: "name"}),
    series: componentFilter({component: "series", labelfield: "title"})
}

const sortable = true;
const filterable = true;

const preferredStyles = {

    program_name: {
        header: 'Program',
        sortable,
        filterable,
    },
    net_saleprice: {
        header: 'Nettó ár',
        sortable,
        filterable,
        renderer: CurrencyFormatter,
        className: "currency"
    },

    saleprice: {
        header: 'Eladási ár',
        sortable,
        filterable,
        renderer: CurrencyFormatter,
        className: "currency"
    },
    saleprice_all: {
        header: 'Eladás',
        sortable,
        filterable,
        renderer: CurrencyFormatter,
        className: "currency"
    },
    saleprice_final: {
        header: 'Eladás (lezárt)',
        sortable,
        filterable,
        renderer: CurrencyFormatter,
        className: "currency"
    },
    listprice: {
        header: 'Lista ár',
        sortable,
        filterable,
        renderer: CurrencyFormatter
    },
    displayname: {
        header: 'Megnevezés',
        sortable,
        filterable
    },
    name: {
        header: 'Megnevezés',
        sortable,
        filterable
    },
    qty: {
        header: 'Mennyiség',
        sortable,
        filterable,
        renderer: (value, row) => UnitFormatter(value, row.unit),
        className: "unit"
    },
    category: {
        header: 'Típus',
        sortable,
        filterable: componentFilter({component: "ProductCategory", labelfield: "name"}),
        renderer: (value) => <div className="nowrap">{remoteComponentFormatter({component: "ProductCategory", labelfield: "name"})(value)}</div>
    },
    pos: {
        header: 'Bolt(ok)',
        sortable,
        filterable: componentFilter({component: "PointOfSale", labelfield: "name"}),
        renderer: (value) => <div className="nowrap">{remoteComponentFormatter({component: "PointOfSale", labelfield: "name"})(value)}</div>
    },
    year: {
        header: 'Év',
        sortable,
        filterable
    },
    quarter: {
        header: 'Negyed év',
        sortable,
        filterable
    },
    half: {
        header: 'Fél év',
        sortable,
        filterable
    },
    month: {
        header: 'Hónap',
        sortable,
        filterable,
        renderer: (value) => moment().month(value - 1).format("MMMM")
    },
    day: {
        header: 'Nap',
        sortable,
        filterable,
        renderer: (value, rowdata) => <span className="nowrap">{value + ". " + moment(rowdata.year + "-" + rowdata.month + "-" + rowdata.day, "YYYY-MM-DD").format("dddd")}</span>
    },
}

// Az elmúlt
// Az eltelt

const filterTypes = {
    Select: (props) => <div className="form-group">
        <Select
            {...props}
            optionsTemplate={props.optionsTemplate && formatters[props.optionsTemplate]}
            saveChanges={(field, value) => {
                if (props.isMulti) {
                    if (Array.isArray(value)) {
                        if (value.length) {
                            props.saveChanges(field, value);
                            return;
                        }
                    }
                    props.saveChanges(field, undefined);
                } else {
                    if (props.objectValue) {
                        if (props.settings.valueField) {
                            value = get(value, props.settings.valueField || props.valueKey);
                        }
                    }
                    props.saveChanges(field, value);
                }
            }}
        />
    </div>,
    Text: (props) => <div className="form-group">
        <TextInput {...props} />
    </div>,
    Pos: (props) => <div className="form-group">
        <PosFilter
            {...props}
        />
    </div>,
    Period: (props) => <div className="form-group">
        <Period
            {...props}
        />
    </div>,
    ComparePeriod: (props) => <div className="row">
        <PeriodTabs
            {...props}
        />
    </div>
}

class Filters extends React.Component {

    render() {

        let filters = [];
        if (!Array.isArray(this.props.filters)) {
            filters = [this.props.filters];
        } else {
            filters = [...this.props.filters];
        }
        return (
            <div>
                {filters.map((filter, idx) => {
                    const stat = this.props.stat;
                    const name = filter.name;
                    const fieldName = filter.field || name;
                    let props = {...filter.props};
                    props.required = props.required || filter.required;
                    const settings = {...filter.settings};
                    const values = JSON.parse(JSON.stringify((this.props.filterSettings || {})[name] || {}));
                    props.value = props.value || get(values, name);
                    props.saveChanges = (field, value) => {
                        const values = JSON.parse(JSON.stringify((this.props.filterSettings || {})[name] || {}));
                        let view = {};
                        const groupBy = {
                            by: []
                        };
                        set(values, field, value);
                        if (settings.visible !== undefined || settings.visible !== null) {
                            if (
                                (
                                    settings.visible === "aggregation"
                                    &&
                                    (((stat.repositoryconfig || {}).aggregations || {}).by || []).indexOf(fieldName) === -1
                                )
                            ) {
                                groupBy.by.push(fieldName);
                                view = addToView(view, fieldName);
                            }
                        }
                        let filter = [];
                        if (settings.valueAsFilter) {
                            if (typeof settings.valueAsFilter === "string") {
                                filter = get(value, settings.valueAsFilter);
                            } else {
                                filter = value;
                            }
                        } else {
                            if (value) {
                                filter = JSON.parse(JSON.stringify(settings.filter || {
                                    field: fieldName,
                                    value
                                }).replace(/\{{2}(.+)\}{2}/, function (match, path) {
                                    return get(value, path);
                                }));
                            } else {
                                filter = [];
                            }
                        }
                        if (filter) {
                            if (filter.value !== undefined) {
                                if (filter.value === null && settings.nullable) {
                                    filter.operator = "isnull";
                                }
                                if (Array.isArray(filter.value)) {
                                    filter.operator = "in";
                                }
                            }
                        } else {
                            filter = [];
                        }
                        values.filter = filter;
                        values.view = view;
                        values.groupBy = groupBy;
                        this.props.setFieldValue(name, values);
                    };
                    let Type = () => "No type for filter!";
                    if (filter.type && filterTypes[filter.type]) {
                        Type = filterTypes[filter.type];
                    }
                    return <div key={idx} className="col-md-12">
                        <Type
                            {...props}
                            settings={settings}
                            name={name}
                            values={(this.props.filterSettings || {})[name]}
                            stat={this.props.stat}
                            setFilter={(value) => this.props.setFieldValue(name, value)}
                        />
                    </div>;
                })}
            </div>
        );
    }
}

class Period extends React.Component {

    componentDidMount() {
        if (this.props.values === null || this.props.values === undefined || !Object.keys(this.props.values).length) {
            this.props.setFilter(this.getValues());
        }
    }

    getValues = () => {
        const date = moment().format("YYYY-MM-DD");
        const ret = JSON.parse(JSON.stringify(this.props.values === null || this.props.values === undefined || !Object.keys(this.props.values).length ? {
            from: date,
            to: date,
            parameters: this.props.periodfield === false ? {} : {periodtype: this.props.periodtype || "created_at"},
            filter: [{
                field: "period",
                value: [date, date].map((date, i) => i === 0 ? date + " 00:00:00" : date + " 23:59:59"),
                operator: "between"
            }]
        } : this.props.values));
        ret.parameters = this.props.periodfield === false ? {} : ret.parameters;
        return ret;
    }

    render() {
        const values = this.getValues();
        return (
            <div className="row">
                <div className="col-md-12">
                    {this.props.periodfield !== false ? <Select
                        storeType="local"
                        labelKey="label"
                        valueKey="key"
                        objectValue={false}
                        value={values.parameters.periodtype}
                        placeholder="Dátum típusa"
                        options={this.props.periodtypes || [
                            {
                                key: "created_at",
                                label: "Rendelés leadásának időpontja szerint"
                            },
                            {
                                key: "transaction_date",
                                label: "Tranzakciós dátum szerint"
                            },
                        ]}
                        label={false}
                        saveChanges={(field, periodtype) => {
                            this.props.setFilter({parameters: {periodtype}});
                        }}
                    /> : null}
                </div>
                <div className="col-md-6">
                    <DateTimeInput
                        label={false}
                        maxDate={values.to}
                        value={values.from}
                        saveChanges={(field, from) => {
                            this.props.setFilter({
                                from,
                                to: values.to,
                                filter: [{
                                    field: "period",
                                    value: [from, values.to].map((date, i) => i === 0 ? date + " 00:00:00" : date + " 23:59:59"),
                                    operator: "between"
                                }]
                            });
                        }}
                    />
                </div>
                <div className="col-md-6">
                    <DateTimeInput
                        label={false}
                        minDate={values.from}
                        value={values.to}
                        saveChanges={(field, to) => {
                            this.props.setFilter({
                                from: values.from,
                                to,
                                filter: [{
                                    field: "period",
                                    value: [values.from, to].map((date, i) => i === 0 ? date + " 00:00:00" : date + " 23:59:59"),
                                    operator: "between"
                                }]
                            });
                        }}
                    />
                </div>
            </div>
        );
    }
}

const periodCalc = (year) => {
    return [
        ...(new Date().getFullYear() === year ? [{type: "yesterday", name: "Tegnap", from: moment().subtract(1, 'day').startOf('day').format("YYYY-MM-DD"), to: moment().subtract(1, 'day').endOf('day').format("YYYY-MM-DD")}] : []),
        {type: "today", name: "Mai nap", from: moment().startOf('day').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")},
        ...(
            new Date().getFullYear() !== year ?
                [{name: "Az nap", from: moment().year(year).startOf('day').format("YYYY-MM-DD"), to: moment().year(year).endOf('day').format("YYYY-MM-DD")}]
                :
                []
        ),
        ...quarters(year),
        ...halfyears(year),
        ...fullyear(year),
        ...months(year),
    ];
}

class PeriodFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            other: this.props.noOther !== true ? !!(this.getData(props).selectedOption || {}).other : false
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const selected = this.getData(this.props).selectedOption;
        const other = !!(selected || {}).other;
        const prevSelected = this.getData(prevProps).selectedOption;
        const prevOther = !!(prevSelected || {}).other;
        if (other !== prevOther || !isEqual(selected, prevSelected) || !isEqual(this.props.noOther, prevProps.noOther)) {
            this.setState({
                other: this.props.noOther !== true ? other : false
            });
        }
    }

    getData = (props, state) => {
        const period = props.values[props.name || "period"] || {};
        const year = parseInt(moment(period.from, "YYYY-MM-DD").format("YYYY"));
        const periods = periodCalc(year);
        if (this.props.noOther !== true) {
            if (periods.find((p) => p.from + "-" + p.to === period.from + "-" + period.to)) {
                periods.push({name: "egyéb", from: null, to: null, other: true});
            } else {
                periods.push({name: "egyéb", ...period, other: true});
            }
        }
        let selectedKey = null;
        let selectedOption = null;
        const options = periods.map((periodus) => {
            const key = periodus.from+"-"+periodus.to;
            const option = {key, ...periodus};
            if (period.from+"-"+period.to === key || ((state || {}).other && option.other)) {
                selectedKey = key;
                selectedOption = option;
            }
            return option;
        });
        return {options,period,selectedKey,selectedOption};
    }

    render() {
        const {options,period,selectedKey} = this.getData(this.props, this.state);

        const year = <div className="form-group"><TextInput
            type="number"
            label={false}
            value={parseInt(moment(period.from, "YYYY-MM-DD").format("YYYY"))}
            saveChanges={(field, value) => {
                const from = moment(period.from, "YYYY-MM-DD").year(value).format("YYYY-MM-DD");
                const to = moment(period.to, "YYYY-MM-DD").year(value).format("YYYY-MM-DD");
                this.props.setFieldValue(this.props.name || "period", {from, to});
            }}
        /></div>;

        const periods = <div className="form-group"><Select
            storeType="local"
            labelKey="name"
            valueKey="key"
            value={selectedKey}
            options={options}
            label={false}
            saveChanges={(field, period) => {
                if (period.other) {
                    this.setState({other: true});
                } else {
                    this.props.setFieldValue(this.props.name || "period", {
                        from: period.from,
                        to: period.to,
                        type: period.type,
                        value: period.value
                    });
                }
            }}
        /></div>;

        const other = this.state.other && <Fragment>
            <div className="col-md-6">
                <div className="form-group">
                    <DateTimeInput
                        maxDate={period.to}
                        value={period.from}
                        label={false}
                        saveChanges={(field, from) => {
                            const {selectedOption} = this.getData({values: {period: {from, to: period.to}}});
                            this.props.setFieldValue(this.props.name || "period", {
                                from,
                                to: period.to,
                                type: (selectedOption|| {}).type || "other",
                                value: (selectedOption|| {}).value || null
                            });
                        }}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <DateTimeInput
                        minDate={period.from}
                        value={period.to}
                        label={false}
                        saveChanges={(field, to) => {
                            const {selectedOption} = this.getData({values: {period: {to, from: period.from}}});
                            this.props.setFieldValue(this.props.name || "period", {
                                from: period.from,
                                to,
                                type: (selectedOption|| {}).type || "other",
                                value: (selectedOption|| {}).value || null
                            });
                        }}
                    />
                </div>
            </div>
        </Fragment>;

        if (this.props.layout) {
            return this.props.layout(year, periods, other);
        }

        return (
            <div className="row">
                <div className="col-md-4">
                    {year}
                </div>
                <div className="col-md-8">
                    {periods}
                </div>
                {other}
            </div>
        );
    }
}

class PeriodTabs extends React.Component {

    static defaultValues = {
        type: "period",
        period: {
            from: moment().startOf('year').format("YYYY-MM-DD"),
            to: moment().endOf('year').format("YYYY-MM-DD")
        },
        format: "day",
        by: "past",
        repeat: 2,
        repeatEnd: moment().endOf('year').format("YYYY") - 2
    };

    componentDidMount() {
        if (this.props.values === null || this.props.values === undefined || !Object.keys(this.props.values).length) {
            this.setFieldValue(null, null);
        }
    }

    getValues = () => {
        const ret = JSON.parse(JSON.stringify(this.props.values === null || this.props.values === undefined || !Object.keys(this.props.values).length ? (this.props.defaults || PeriodTabs.defaultValues) : this.props.values));
        if (ret.period.type && !ret.period.from && !ret.period.to) {
            if (["year","month","day"].indexOf(ret.period.type) !== -1) {
                ret.period = {
                    ...ret.period,
                    from: moment().startOf(ret.period.type).format("YYYY-MM-DD"),
                    to: moment().endOf(ret.period.type).format("YYYY-MM-DD"),
                };
                ret.repeatEnd = parseInt(moment().format("YYYY")) - parseInt(ret.repeatTo || 2);
            } else {
                if (ret.period.type === "yesterday") {
                    ret.period = {
                        ...ret.period,
                        from: moment().subtract(1, 'day').startOf('day').format("YYYY-MM-DD"),
                        to: moment().subtract(1, 'day').endOf('day').format("YYYY-MM-DD"),
                    };
                } else if (ret.period.type === "today") {
                    ret.period = {
                        ...ret.period,
                        from: moment().startOf('day').format("YYYY-MM-DD"),
                        to: moment().endOf('day').format("YYYY-MM-DD"),
                    };
                }
            }
        }
        ret.parameters = this.props.periodfield === false ? {} : (ret.parameters || {periodtype: this.props.periodtype || "created_at"});
        return ret;
    }

    setFieldValue = (field, value) => {
        const filter = [];
        let view = {};
        const groupBy = {
            by: []
        };
        const values = this.getValues();
        values.filename = null;
        if (field !== null) {
            set(values, field, value);
        }
        if (values.type === "period") {
            if (values.period.from) {
                let dates = [values.period.from, values.period.to].filter((date) => !!date);
                if (dates.length === 1) {
                    dates = [dates, dates];
                }
                filter.push({
                    field: "period",
                    value: dates.map((date, i) => i === 0 ? date + " 00:00:00" : date + " 23:59:59"),
                    operator: "between"
                });
                const periods = periodCalc(values.period.from.substr(0,4));
                const c = periods.find((period) => period.from === values.period.from && period.to === values.period.to);
                if (c) {
                    c.name = values.period.from.substr(0,4) + " " + c.name;
                }
                values.filename = (c || {name: values.period.from + " - " + values.period.to}).name;
            }
        } else if (values.type === "compare") {
            if (values.by === "history") {
                groupBy.by.push("year");

                const historyFilter = [];
                const from = moment(values.period.from, "YYYY-MM-DD");
                const to = moment(values.period.to, "YYYY-MM-DD");
                if (moment().diff(moment(values.period.from + " 00:00:00", "YYYY-MM-DD HH:mm:ss")) > 0 && moment().diff(moment(values.period.to + " 23:59:59", "YYYY-MM-DD HH:mm:ss")) < 0 && values.yearToDate) {
                    to.month(moment().format("MM")-1).date(moment().format("DD")-0);
                }
                if (values.period.type !== "other" && ["year","month","day","half","quarter"].indexOf(values.period.type) !== -1) {
                    view = addToView(view, values.period.type);
                    groupBy.by.push(values.period.type);
                }
                do {
                    historyFilter.push({
                        field: "period",
                        value: [from.format("YYYY-MM-DD"), to.format("YYYY-MM-DD")].map((date, i) => i === 0 ? date + " 00:00:00" : date + " 23:59:59"),
                        operator: "between"
                    });
                    from.year(from.format("YYYY") - 1);
                    to.year(to.format("YYYY") - 1);
                } while (from.format("YYYY") >= values.repeatEnd);
                filter.push({filters: historyFilter, operator: "or"});
                view = addToView(view, "year");
            } else if (values.by === "past") {
                let repeat = parseInt(values.repeat || 2) + 1;
                let pastFilter = [];
                if (values.format === "day") {
                    Array(repeat).fill('').map((v, idx) => {
                        const repeatDate = values.repeatDate ? moment(values.repeatDate, "YYYY-MM-DD") : moment();
                        const d = repeatDate.subtract(repeat - (idx + 1), "days");
                        pastFilter.push({
                            filters: [
                                {field: "year", value: d.format("YYYY")},
                                {field: "month", value: d.format("M")},
                                {field: "day", value: d.format("D")}
                            ]
                        });
                    });
                    filter.push({filters: pastFilter, operator: "or"});
                    groupBy.by.push("month");
                    groupBy.by.push("day");
                    view = addToView(view, values.format);
                } else if (values.format === "month") {
                    Array(repeat).fill('').map((v, idx) => {
                        const repeatDate = values.repeatDate ? moment(values.repeatDate, "YYYY-MM-DD") : moment();
                        const d = repeatDate.subtract(repeat - (idx + 1), "months");
                        pastFilter.push({
                            filters: [
                                {field: "year", value: d.format("YYYY")},
                                {field: "month", value: d.format("M")},
                            ]
                        });
                    });
                    filter.push({filters: pastFilter, operator: "or"});
                    groupBy.by.push("month");
                    view = addToView(view, values.format);
                } else if (values.format === "year") {
                    Array(repeat).fill('').map((v, idx) => {
                        const repeatDate = values.repeatDate ? moment(values.repeatDate, "YYYY-MM-DD") : moment();
                        const d = repeatDate.subtract(repeat - (idx + 1), "years");
                        pastFilter.push({
                            filters: [
                                {field: "year", value: d.format("YYYY")},
                            ]
                        });
                    });
                    filter.push({filters: pastFilter, operator: "or"});
                    view = addToView(view, values.format);
                } else if (values.format === "quarter") {
                    Array(repeat).fill('').map((v, idx) => {
                        const repeatDate = values.repeatDate ? moment(values.repeatDate, "YYYY-MM-DD") : moment();
                        const d = repeatDate.subtract(repeat - (idx + 1), "quarters");
                        pastFilter.push({
                            filters: [
                                {field: "year", value: d.format("YYYY")},
                                {field: "quarter", value: d.quarter()},
                            ]
                        });
                    });
                    filter.push({filters: pastFilter, operator: "or"});
                    groupBy.by.push("quarter");
                    view = addToView(view, values.format);
                    view = addToView(view, "year");
                } else if (values.format === "half") {
                    Array(repeat).fill('').map((v, idx) => {
                        const repeatDate = values.repeatDate ? moment(values.repeatDate, "YYYY-MM-DD") : moment();
                        const d = repeatDate.subtract((repeat - (idx + 1)) * 2, "quarters");
                        pastFilter.push({
                            filters: [
                                {field: "year", value: d.format("YYYY")},
                                {field: "half", value: d.quarter() <= 2 ? 1 : 2},
                            ]
                        });
                    });
                    filter.push({filters: pastFilter, operator: "or"});
                    groupBy.by.push("half");
                    view = addToView(view, values.format);
                    view = addToView(view, "year");
                }
                groupBy.by.push("year");
                groupBy.by.push(values.format);
            }
        }
        values.filter = {filters: filter};
        values.view = view;
        values.groupBy = groupBy;
        this.props.setFilter(values);
    }

    visibleType = (type) => {
        return (this.props.types === null && 2) || (this.props.types === undefined && 2) || (this.props.types === type && 1) || (Array.isArray(this.props.types) && this.props.types.indexOf(type) !== -1 && this.props.types.length) || (this.props.types[type] && Object.keys(this.props.types).length);
    }

    render() {
        const formats = [
            {
                key: "day",
                label: "Nap"
            },
            {
                key: "month",
                label: "Hónap"
            },
            {
                key: "quarter",
                label: "Negyed év"
            },
            {
                key: "half",
                label: "Fél év"
            },
            {
                key: "year",
                label: "Év"
            }
        ];
        const values = this.getValues();
        const periodtype = <div className="col-md-12">
            <div className="form-group">
                {this.props.periodfield !== false ? <Select
                    storeType="local"
                    labelKey="label"
                    valueKey="key"
                    objectValue={false}
                    value={values.parameters.periodtype}
                    placeholder="Dátum típusa"
                    options={this.props.periodtypes || [
                        {
                            key: "created_at",
                            label: "Rendelés leadásának időpontja szerint"
                        },
                        {
                            key: "transaction_date",
                            label: "Tranzakciós dátum szerint"
                        },
                    ]}
                    label={false}
                    saveChanges={(field, periodtype) => {
                        this.setFieldValue("parameters.periodtype", periodtype);
                    }}
                /> : null}
            </div>
        </div>;
        const period = this.visibleType("period") && <PeriodFilter values={values} setFieldValue={(field, value) => this.setFieldValue(field, value)} />;
        const compare = this.visibleType("compare") && <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <RadioGroup
                        name="by"
                        objectValue={false}
                        options={[
                            {
                                key: "history",
                                label: "Éves bontás"
                            },
                            {
                                key: "past",
                                label: "Időszak"
                            }
                        ]}
                        valueKey="key"
                        labelKey="label"
                        value={values.by}
                        saveChanges={(field, by) => {
                            this.setFieldValue("by", by)
                        }}
                        label="Összehasonlítás alapja"
                    />
                </div>
            </div>
            {values.by === 'history' ?
                <PeriodFilter values={values} noOther={true} setFieldValue={(field, value) => this.setFieldValue(field, value)} layout={(year, periods, other) => <Fragment>
                    <div className="col-md-12">
                        {periods}
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <TextInput
                                type="number"
                                maxLength={4}
                                label={false}
                                value={values.repeatEnd}
                                saveChanges={(field, repeatEnd) => {
                                    this.setFieldValue("repeatEnd", repeatEnd)
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        {year}
                    </div>
                    {other}
                </Fragment>}/> : <Fragment>
                    <div className="col-md-12">
                        <div className="form-group">
                            <DateTimeInput
                                label={false}
                                showTime={false}
                                value={values.repeatDate || moment().format("YYYY-MM-DD")}
                                saveChanges={(field, repeatDate) => {
                                    this.setFieldValue("repeatDate", repeatDate);
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <Tooltip title={values.by === 'history' ? ("Az elmúlt " + (values.repeat || "x") + " év") : ((values.repeat || 2) + " " + formats.find((f) => values.format === f.key).label)}>
                                <TextInput
                                    type="number"
                                    maxLength={2}
                                    label={false}
                                    placeholder={2}
                                    value={values.repeat}
                                    saveChanges={(field, repeat) => {
                                        this.setFieldValue("repeat", repeat)
                                    }}
                                />
                            </Tooltip>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <Select
                                label={false}
                                name="format"
                                options={formats}
                                valueKey="key"
                                labelKey="label"
                                objectValue={false}
                                storeType="local"
                                value={values.format}
                                saveChanges={(field, format) => {
                                    this.setFieldValue("format", format)
                                }}
                            />
                        </div>
                    </div>
                </Fragment>}
            {values.by === "history" && moment().diff(moment(values.period.from + " 00:00:00", "YYYY-MM-DD HH:mm:ss")) > 0 && moment().diff(moment(values.period.to + " 23:59:59", "YYYY-MM-DD HH:mm:ss")) < 0 && <div className="col-md-12">
                <CheckBox
                    name={"yearToDate"}
                    value={values.yearToDate}
                    label="Mai nappal bezárólagosan"
                    saveChanges={(field, yearToDate) => {
                        this.setFieldValue("yearToDate", yearToDate);
                    }}/>
            </div>}
        </div>;
        if (period && compare) {
            return (
                <Fragment>
                    {periodtype}
                    <Tabs
                        className="radio-style"
                        theme="default"
                        currentTab={values.type}
                        onTabChange={(type) => this.setFieldValue("type", type)}
                    >
                        {period && <TabContent
                            tabLabel="Periódus"
                            tabName="period"
                        >
                            {period}
                        </TabContent>}
                        {compare && <TabContent
                            tabLabel="Összehasonlítás"
                            tabName="compare"
                        >
                            {compare}
                        </TabContent>}
                    </Tabs>
                </Fragment>
            );
        } else {
            if (period) {
                return <div className="col-md-12">{periodtype}{period}</div>
            } else if (compare) {
                return <div className="col-md-12">{periodtype}{compare}</div>
            }
        }
    }
}

class PosFilter extends React.Component {

    static defaultValues = {

    };

    getValues = () => {
        return JSON.parse(JSON.stringify(this.props.values === null || this.props.values === undefined || !Object.keys(this.props.values).length ? PosFilter.defaultValues : this.props.values));
    }

    setFieldValue = (field, value) => {
        const stat = this.props.stat;
        const filter = [];
        let view = {};
        const groupBy = {
            by: []
        };
        const values = this.getValues();
        set(values, field, value);
        if (Array.isArray(values.pos) && values.pos.length) {
            filter.push({
                field: "pos",
                value: Array.isArray(values.pos) ? values.pos.map((pos) => pos.id) : values.pos.id,
                operator: "in"
            });
            if (!values.groupByPos && (((stat.repositoryconfig || {}).aggregations || {}).by || []).indexOf("pos") === -1) {
                values.pos.length > 1 && groupBy.by.push("pos");
                if (values.pos.length > 1) {
                    view = addToView(view, "pos");
                }
            }
        }
        values.filter = filter;
        values.view = view;
        values.groupBy = groupBy;
        this.props.setFilter(values);
    }

    render() {
        const values = this.getValues();
        const visiblePos = (((this.props.stat.repositoryconfig || {}).aggregations || {}).by || []).indexOf("pos") !== -1;
        const selectedPos = (Array.isArray(values.pos) && values.pos.length) || 0;
        const isMulti = this.props.isMulti !== undefined ? this.props.isMulti : true;
        return (
            <Fragment>
                <Select
                    label={this.props.label !== undefined ? this.props.label : false}
                    placeholder={this.props.placeholder}
                    name="pos"
                    component="PointOfSale"
                    isClearable={true}
                    isMulti={isMulti}
                    objectValue={true}
                    labelKey="name"
                    storeType="local"
                    value={isMulti ? values.pos : (Array.isArray(values.pos) ? values.pos[0] : values.pos)}
                    saveChanges={(field, pos) => {
                        if (pos !== null) {
                            this.setFieldValue("pos", !isMulti ? (!Array.isArray(pos) ? [pos] : pos) : pos);
                        } else {
                            this.setFieldValue("pos", null);
                        }
                    }}
                />
                {!visiblePos && selectedPos > 1 && <div className="row">
                    <div className="col-md-12">
                        <CheckBox
                            name={"groupByPos"}
                            value={values.groupByPos}
                            label="Kiválasztott boltok összesítve"
                            saveChanges={(field, groupByPos) => {
                                this.setFieldValue("groupByPos", groupByPos);
                            }}/>
                    </div>
                </div>}
            </Fragment>
        );
    }
}

class FilterComponent extends React.Component {

    render() {
        const stat = this.props.stat;
        //const posFilter = visiblePos || (selectedPos && !this.props.values.groupByPos);
        const filterSettings = JSON.parse(JSON.stringify(this.props.values.filterSettings || {}));
        return (
            <Fragment>
                <div className="row">
                    <Filters stat={stat} filters={(stat.settings || {}).filters || []} filterSettings={filterSettings} setFieldValue={(filter, value) => this.props.setFieldValue("filterSettings", {...filterSettings, [filter]: value})} />
                </div>
                {/*<Select
                    label="Csoport sorrend"
                    name="sort"
                    options={posFilter ? [
                        {
                            key: "none",
                            label: "Nincs"
                        },
                        {
                            key: "pos",
                            label: "Boltok szerint"
                        },
                        {
                            key: "date",
                            label: "Idő szerint"
                        }
                    ] : [
                        {
                            key: "none",
                            label: "Nincs"
                        },
                        {
                            key: "date",
                            label: "Idő szerint"
                        }
                    ]}
                    valueKey="key"
                    labelKey="label"
                    objectValue={false}
                    storeType="local"
                    value={!posFilter && this.props.values.sort === "pos" ? "date" : this.props.values.sort}
                    saveChanges={(field, sort) => {
                        this.props.setFieldValue("sort", sort);
                    }}
                />*/}
            </Fragment>
        );
    }
}

const addToView = (view, field) => {
    if (Array.isArray(view)) {
        if (view.indexOf(field) === -1) {
            view.unshift(field);
        }
    } else {
        if (view[field] === undefined) {
            const old = {...view};
            view = {};
            view[field] = {};
            view = {...view, ...old};
        }
    }
    return view;
}

















class StatisticsTab extends React.Component {

    getStat = () => {
        return this.props.stat || {};
    }

    getStatSettings = () => {
        return JSON.parse(JSON.stringify(this.props.values.statSettings === null || this.props.values.statSettings === undefined || !Object.keys(this.props.values.statSettings).length ? {
            filter: [],
            groupBy: {},
            view: {},
            sortBy: [],
            parameters: {}
        } : this.props.values.statSettings));
    }

    render() {
        const stat = this.getStat();

        const statSettings = this.getStatSettings();

        let settings = JSON.parse(JSON.stringify(Array.isArray(stat.settings) ? [...(stat.settings || [])] : {...(stat.settings || {})}));

        const aggregations = stat.listaggregations ? JSON.parse(JSON.stringify(stat.listaggregations)) : null;

        let columns = null;
        let view = statSettings.view;

        if (view) {
            columns = {};
            if (Array.isArray(view)) {
                view.map((column) => {
                    if ((settings.columns || {})[column]) {
                        columns[column] = settings.columns[columns];
                    } else {
                        columns[column] = {sortable: true, filterable: true, ...(preferredStyles[column] || {})};
                    }
                    if (columns[column].sortable === undefined) {
                        columns[column].sortable = true;
                    }
                    if (columns[column].filterable === undefined) {
                        columns[column].filterable = true;
                    }
                });
            } else {
                Object.keys(view).map((column) => {
                    //const col = {sortable: true, filterable: true, ...(preferredStyles[column] || {}), ...view[column]};
                    let col = view[column];
                    if (typeof col === "string" || Object.keys(col).length === 0) {
                        if ((settings.columns || {})[column]) {
                            col = {...settings.columns[columns]};
                        } else {
                            col = {sortable: true, filterable: true, ...(preferredStyles[column] || {})};
                        }
                    }
                    if (col.renderer && typeof col.renderer === "string") {
                        if (renderers[col.renderer]) {
                            col.renderer = renderers[col.renderer];
                        } else {
                            col.renderer = () => "Not valid renderer!";
                        }
                    }
                    if (col.filterable && typeof col.filterable === "string") {
                        if (filterables[col.filterable]) {
                            col.filterable = filterables[col.filterable];
                            col.operator = '='; // TODO ez a filterable-be kéne hogy ott állítsuk
                        }
                    }
                    columns[column] = col;
                    if (columns[column].sortable === undefined) {
                        columns[column].sortable = true;
                    }
                    if (columns[column].filterable === undefined) {
                        columns[column].filterable = true;
                    }
                });
            }
        }

        const filterSettings = JSON.parse(JSON.stringify(this.props.values.filterSettings || {}));

        const params = {
            name: ((stat.settings || {}).filters || []).map((settingsFilter) => {
                if (settingsFilter.name) {
                    const name = settingsFilter.name;
                    if (filterSettings[name]) {
                        return filterSettings[name].filename;
                    }
                }
                return "";
            }).join(" ").trim() || null
        };

        return <Fragment>
            <div className="row">
                <div className="col-md-3">
                    <FilterComponent stat={stat} setFieldValue={this.props.setFieldValue} values={this.props.values}/>
                    {this.props.nav}
                </div>
                <div className="col-md-9">
                    {/*!!Object.keys(stat).length && statSettings.ok && <PivotTableUI
                        data={data}
                        onChange={s => this.setState(s)}
                        {...this.state}
                    />*/}
                    {!!Object.keys(stat).length && statSettings.ok && <SelectorGrid
                        className={"p-small-table"}
                        pageSize={50}
                        pageSizes={[5,10,25,50,100]}
                        component="Statistics"
                        reqparams={{option: "Statistics", [this.props.componentConfig.idfield]: stat[this.props.componentConfig.idfield]}}
                        filter={statSettings.filter}
                        parameters={statSettings.parameters}
                        groupBy={statSettings.groupBy}
                        columns={columns}
                        aggregations={aggregations}
                        sortBy={statSettings.sortBy}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", params}]}
                    />}
                </div>
            </div>
        </Fragment>;
    }
}

class StatisticsEditor extends React.Component {

    state = {
        isLoading: false,
    }

    loadStatistics = async () => {
        const statistics = await sendRequest({
            option: "componentlist",
            component: "Statistics",
            itemsperpage: 0
        });
        this.props.setFieldValue("statistics", statistics.items);
    }

    componentDidMount() {
        this.loadStatistics();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values.currentTab !== prevProps.values.currentTab || !isEqual((this.props.values.tabs || {})[this.props.values.currentTab], (prevProps.values.tabs || {})[prevProps.values.currentTab])) {
            this.onTabChanged();
        }
    }

    getCurrentTabs = () => {
        return this.props.values.tabs || [];
    }

    getCurrentTab = () => {
        return this.props.values.currentTab || 0;
    }

    createNewTab = async (stat) => {
        this.setState({isLoading: true}, async () => {
            const currentTabs = this.getCurrentTabs();
            stat = await loadComponentById(this.props.componentConfig.componentname, stat[this.props.componentConfig.idfield]);
            this.props.setFieldValue("tabs", [...currentTabs, {stat, values: {}}]);
            this.props.setFieldValue("currentTab", currentTabs.length);
            this.setState({isLoading: false});
        });
    }

    removeTab = (tabIndex) => {
        const currentTabs = this.getCurrentTabs();
        const currentTab = this.getCurrentTab();
        this.setState({isLoading: true}, async () => {
            if (currentTab === currentTabs.length - 1) {
                this.props.setFieldValue("currentTab", currentTabs.length - 2);
            } else {
                this.props.setFieldValue("currentTab", currentTab);
            }
            currentTabs.splice(tabIndex, 1);
            this.props.setFieldValue("tabs", currentTabs);
            this.setState({isLoading: false});
        });
    }

    onTabChanged = () => {
        const currentTabs = this.getCurrentTabs();
        const tabIndex = this.getCurrentTab();
        if (!currentTabs[tabIndex]) return;
        const {stat, values} = currentTabs[tabIndex];
        let view = JSON.parse(JSON.stringify(Array.isArray(stat.listview) ? [...(stat.listview || [])] : {...(stat.listview || {})}));

        const filter = [];
        const groupBy = {by: []};
        let sortBy = [];
        let ok = true;
        let parameters = {};

        const filterSettings = JSON.parse(JSON.stringify(values.filterSettings || {}));
        ((stat.settings || {}).filters || []).map((settingsFilter) => {
            if (settingsFilter.name) {
                const name = settingsFilter.name;
                if (filterSettings[name]) {
                    if ((Array.isArray(filterSettings[name].filter) && filterSettings[name].filter.length > 0) || (filterSettings[name].filter !== null && filterSettings[name].filter !== undefined && Object.keys(filterSettings[name].filter).length > 0)) {
                        filter.push(filterSettings[name].filter);
                    } else if (settingsFilter.required) {
                        ok = false;
                    }
                    ((filterSettings[name].groupBy || {}).by || []).map((by) => {
                        if (groupBy.by.indexOf(by) === -1) {
                            groupBy.by.push(by);
                        }
                    });
                    if (Array.isArray(filterSettings[name].view)) {
                        filterSettings[name].view.map((field) => {
                            view = addToView(view, field);
                        });
                    } else if (filterSettings[name].view !== undefined && filterSettings[name].view !== null) {
                        Object.keys(filterSettings[name].view).map((field) => {
                            view = addToView(view, field);
                        });
                    }
                    parameters = {...parameters, ...filterSettings[name].parameters};
                } else if (settingsFilter.required) {
                    ok = false;
                }
            }
        });

        const posFilter = (((stat.repositoryconfig || {}).aggregations || {}).by || []).indexOf("pos") !== -1 || ((Array.isArray(values.pos) && values.pos.length) && !values.groupByPos);

        if (posFilter && values.sort === "pos") {
            sortBy = [{field: "pos", direction: "asc"},{field: "date", direction: "desc"}];
        } else if (values.sort === "none") {

        } else {
            sortBy = [{field: "date", direction: "desc"},{field: "pos", direction: "asc"}];
        }

        this.props.setFieldValue("tabs." + tabIndex + ".values.statSettings", {
            ok,
            filter,
            groupBy,
            view,
            parameters,
            sortBy
        });
    }

    render() {
        if (this.state.isLoading) {
            return <ContentLoader />;
        }
        const currentTabs = this.getCurrentTabs();
        const currentTab = this.getCurrentTab();

        const nav = <ul className="nav nav-pills nav-stacked">
            {(this.props.values.statistics || []).map((_stat, idx) => {
                return (
                    <li key={idx}>
                        <a
                            href=""
                            onClick={(e) => {
                                e && e.preventDefault();
                                this.createNewTab(_stat);
                            }}
                        >
                            {_stat.name}
                        </a>
                    </li>
                );
            })}
        </ul>;

        return (
            <Box {...(currentTabs.length !== 0 ? {theme: "none"} : {})}>
                <div className="row">
                    {currentTabs.length === 0 ?
                        <div className="col-md-3">
                            {nav}
                        </div>
                        :
                        <Tabs
                            theme="default"
                            currentTab={currentTab}
                            defaultTab={0}
                            onTabChange={(tabName) => {
                                this.props.setFieldValue("currentTab", tabName);
                            }}
                        >
                            {currentTabs.map(
                                (statData, tabIndex) => {
                                    return <TabContent
                                        key={tabIndex}
                                        tabLabel={<Fragment>
                                            {((statData.stat || {}).name || "Új") + " "}
                                            <Button
                                                icon={{lib: "fa", name: "times"}}
                                                size="xs"
                                                color="danger"
                                                onClick={(e) => {
                                                    e && e.preventDefault();
                                                    this.removeTab(tabIndex);
                                                }}
                                            />
                                        </Fragment>}
                                        tabName={tabIndex}
                                    >
                                        <div className="row">
                                            <div className="col-md-12 stats">
                                                <StatisticsTab
                                                    statistics={this.props.values.statistics}
                                                    nav={nav}
                                                    stat={statData.stat}
                                                    values={statData.values}
                                                    componentConfig={this.props.componentConfig}
                                                    setFieldValue={(field, value) => {
                                                        this.props.setFieldValue("tabs." + tabIndex + ".values." + field, value);
                                                        this.onTabChanged();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </TabContent>
                                }
                            )}
                        </Tabs>}
                </div>
            </Box>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createEditor({componentName: "Statistics", WrappedComponent: StatisticsEditor, editor: "Statistics3"}));